import { Link, useSearchParams } from "react-router";

type Props = {
  page: number;
  totalPages: number;
};

const linkClass = "rounded-md border border-slate-300 bg-white px-3 py-1.5 text-sm hover:bg-slate-50";
const disabledClass = "rounded-md border border-slate-200 px-3 py-1.5 text-sm text-slate-400";

function PageLink({ to, disabled, children }: { to: number; disabled: boolean; children: string }) {
  const [searchParams] = useSearchParams();

  if (disabled) return <span className={disabledClass}>{children}</span>;

  // Keep other params (e.g. the search query) when changing page.
  const params = new URLSearchParams(searchParams);
  params.set("page", String(to));

  return (
    <Link to={`?${params}`} className={linkClass}>
      {children}
    </Link>
  );
}

export default function Pagination({ page, totalPages }: Props) {
  return (
    <nav className="flex flex-wrap items-center justify-between gap-2">
      <div className="flex gap-2">
        <PageLink to={1} disabled={page <= 1}>« First</PageLink>
        <PageLink to={page - 1} disabled={page <= 1}>‹ Prev</PageLink>
      </div>
      <span className="text-sm text-slate-600">
        Page {page} of {totalPages}
      </span>
      <div className="flex gap-2">
        <PageLink to={page + 1} disabled={page >= totalPages}>Next ›</PageLink>
        <PageLink to={totalPages} disabled={page >= totalPages}>Last »</PageLink>
      </div>
    </nav>
  );
}
